import { render, staticRenderFns } from "./detail_tc.vue?vue&type=template&id=6b581022&scoped=true&"
import script from "./detail_tc.vue?vue&type=script&lang=js&"
export * from "./detail_tc.vue?vue&type=script&lang=js&"
import style0 from "./detail_tc.vue?vue&type=style&index=0&id=6b581022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b581022",
  null
  
)

export default component.exports